import { createFileRoute } from '@tanstack/react-router';
import { ExternalContactDetailPage } from '@/pages/organization/external-contacts/ExternalContactDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/external-contacts/$externalContactId')({
  loader: createEntityBreadcrumbLoader('externalContact', 'externalContactId'),
  component: RouteComponent
});

function RouteComponent() {
  const { externalContactId } = Route.useParams();
  return <ExternalContactDetailPage externalContactId={externalContactId} />;
}
